import { VDirective, VServices } from '@libTs/vue-base';
import { DirectiveBinding } from 'vue/types/options';

export const NavDirective: VDirective = [
  'nav',
  {
    bind( el: HTMLElement, binding: DirectiveBinding ) {
      $( el ).on( 'click', () => {
        const navToActivate = $( el ).next();
        const icon = $( el ).find( 'i.circle' );
        if ( navToActivate[ 0 ] ) {
          if ( navToActivate.hasClass( 'hidden' ) ) {
            navToActivate.removeClass( 'hidden' );
            icon.removeClass( "fa-plus-circle" );
            icon.addClass( "fa-minus-circle" );
          } else {
            navToActivate.addClass( 'hidden' );
            icon.addClass( "fa-plus-circle" );
            icon.removeClass( "fa-minus-circle" );
          }
        }
      } );
      $( function () {
        if ( binding.arg === 'width' ) {
          $( el ).parent().css( 'width', $( '.header-button-grid' ).innerWidth() + 'px' );
        }
      } );
    },
  },
];
